import { createClient } from '@/lib/supabase/client'

// The signed-in reader's referral code, for the links they share (lib/share),
// or null for a guest. Read once per page load and kept: the share sheet has
// to open inside the tap, with nothing left to wait for. getSession reads the
// browser's own session, so a guest costs no request.
let pending = null

export function myReferralCode() {
  if (!pending) {
    pending = (async () => {
      try {
        const supabase = createClient()
        const {
          data: { session },
        } = await supabase.auth.getSession()
        if (!session?.user) return null
        const { data } = await supabase
          .from('users')
          .select('referral_code')
          .eq('id', session.user.id)
          .maybeSingle()
        return data?.referral_code || null
      } catch {
        return null
      }
    })()
  }
  return pending
}
